<script lang="ts">
  let {
    back,
    inactive,
  }: {
    back: () => void;
    inactive: boolean;
  } = $props();
</script>

<div class="h-full">
  <p>
    Thank you for clarifying that. We can only submit a claim on behalf of the
    person whose name is on the finance agreement.
  </p>
  <p>
    If the person who financed the vehicle wishes to proceed with filing a
    claim, instructions will be available on the following page.
  </p>
</div>

<div class="floating-footer">
  <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  <button type="submit" class="btn btn-primary" disabled={inactive}>Request case closure</button>
</div>
